const frenzy_get_product_json = async function(url, html, data){

    const response = await fetch(url,{method: "GET"});
    const product = await response.json();
    if(product){
        document.querySelectorAll('.FrenzyProductId_'+product.id).forEach(function(this_section){
          let getVariantID = '';
          if(this_section){
            getVariantID = this_section.getAttribute("data-variantid"); 
             let getCurrentVariant = '';
             let newPrice = '';
             let newComparePrice = '';
             let price = '';
             let compare_price = '';
            if(getVariantID.length < 14){
                getCurrentVariant = product.variants[0];
                newPrice = Math.round(getCurrentVariant.price / 100);
                newComparePrice = Math.round(getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price / 100 : 0);
                price =  money_format_Frenzy(getCurrentVariant.price / 100 * 100, frenzy_shop_currency);
                compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency);  
            }else{
              getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
              newPrice = Math.round(getCurrentVariant.price / 100);
              newComparePrice = Math.round(getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price / 100 : 0);
              price =  money_format_Frenzy(getCurrentVariant.price / 100 * 100, frenzy_shop_currency);
              compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency);  
            }
            this_section.querySelector('.frenzy_product_price_sale').innerHTML = '<span class="money">'+price+'</span>';
            if(getCurrentVariant.compare_at_price > getCurrentVariant.price && getCurrentVariant.compare_at_price != 0  && getCurrentVariant.compare_at_price != null){
              this_section.querySelector('.frenzy_product_price_compare').innerHTML = '<span class="money">'+compare_price+'</span>';  
              // this_section.querySelector('.frenzy_product_price_compare').innerHTML = '';  
            }
          }
        });
    }
}

const get_product_metafields_json = async function(url, html){
    const response = await fetch(url,{method: "GET"});
    const product = await response.json();
/*
    if(product){
        document.querySelectorAll('.FrenzyProductId_'+product.id).forEach(function(this_section){
          let getVariantID = '';
          if(this_section){
            getVariantID = this_section.getAttribute("data-variantid"); 
             let getCurrentVariant = '';
             let newPrice = '';
             let newComparePrice = '';
             let price = '';
             let compare_price = '';
            if(getVariantID.length < 14){
                getCurrentVariant = product.variants[0];
                newPrice = Math.round(getCurrentVariant.price / 100);
                newComparePrice = Math.round(getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price / 100 : 0);
                price =  money_format_Frenzy(getCurrentVariant.price / 100 * 100, frenzy_shop_currency);
                compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency);  
            }else{
              getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
              newPrice = Math.round(getCurrentVariant.price / 100);
              newComparePrice = Math.round(getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price / 100 : 0);
              price =  money_format_Frenzy(getCurrentVariant.price / 100 * 100, frenzy_shop_currency);
              compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency);  
            }
            this_section.querySelector('.frenzy_product_price_sale').innerHTML = '<span class="money">'+price+'</span>';
            if(getCurrentVariant.compare_at_price > getCurrentVariant.price && getCurrentVariant.compare_at_price != 0  && getCurrentVariant.compare_at_price != null){
              this_section.querySelector('.frenzy_product_price_compare').innerHTML = '<span class="money">'+compare_price+'</span>';  
              // this_section.querySelector('.frenzy_product_price_compare').innerHTML = '';  
            }
            
			 console.log("get_product_metafields_json:::");
			 console.log(product);
			 
          }
        });
    }
  */
}

window.FrenzyProductGridChangeCallBack = function(html,data){
  var product_id = data?.product_id;
  const varint_id = data.product_id_variant.split("_");
  html.querySelector('.frenzy_product_price_meta').setAttribute("data-variantid",varint_id[1]);
  html.querySelector('.frenzy_product_price_meta').classList.add("FrenzyProductId_"+product_id);
  var product_handle = data?.org_prod_url.split('?') ;
  frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', html, data).then(frenzy_product_response => {return frenzy_product_response});
/*
	console.log("***** " + window.Shopify.routes.root + 'products/'+product_id+'/metafields.js');

  get_product_metafields_json(window.Shopify.routes.root + 'products/'+product_id+'/metafields.json', html).then(product_response => {return product_response});
*/
  let colorCountHtml = '';
  (collection_obj || []).find((x) => {
    if (x.id === data?.smf_swatch_collection && x.count > 0) {
      colorCountHtml += '<span data-handle="'+product_handle[0]+'" data-siblingtext="'+x.count+' colors"></span>';
    }
  });
  document.querySelector('body').insertAdjacentHTML('beforeend',colorCountHtml);
  if(document.querySelector("[data-handle='" + product_handle[0] + "']")){
    html.querySelector('.frenzy_product_item[data-pro_id="'+data?.product_id+'"] .sibling-products').innerHTML = "Available in " + document.querySelector("[data-handle='" + product_handle[0] + "']")?.getAttribute("data-siblingtext");
  }
}

const bundle_frenzy_get_product_json = async function(url, html,settingData){
  jQuery.getJSON(url, function(product) {
          var getVariantID = html.getAttribute('value');
          const $frenzy_bundle_parent = html.closest(
                    ".frenzy_bundle_innercode"
                  );
          // const getVariantID = this_section.getAttribute("data-variantid");
          const getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
          const newPrice = getCurrentVariant.price / 100;
          const newComparePrice = getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price : 0 / 100;
          const max_price = product.price_max;
          const min_price = product.price_min;
          var compare_price = getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price : 0 / 100;
          var price = '';
         
          if(min_price != max_price){
              // price = money_format_Frenzy(newPrice * 100, frenzy_shop_currency);
            price = newPrice * 100;
          }else{
            // price =  money_format_Frenzy(newPrice * 100, frenzy_shop_currency);
            price =  newPrice * 100;
            if(min_price == max_price && newPrice != null && newComparePrice != '' && newPrice < newComparePrice){
               // compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency); 
               compare_price = newComparePrice * 100;
            }
          }
      var frenzy_bundle_sale_price =price;
     if(settingData?.discount_amount > 0){
                    is_discount = true;
                frenzy_bundle_sale_price =
                  settingData?.discount_type == "percentage" ? (price  * (100 - settingData?.discount_amount)) / 100 :price  - settingData?.discount_amount * 100;
            }
          // html.querySelector('.frenzy_bundle_product_main_price').innerHTML = '<span class="money">'+price+'</span>';
        
           html.setAttribute('data-price',frenzy_bundle_sale_price);
           html.setAttribute('data-orgprice',price);
          if(compare_price != ''){
            html.setAttribute('data-org_msrp_price',compare_price);
          }else{
            // html.setAttribute('data-org_msrp_price',price);
          }
          $frenzy_bundle_final_total(
                    $frenzy_bundle_parent,
                    settingData
                  );
  })
}
const FrenzyAfterBundlePriceChangeCallBack = async function(data,settingData){
  const variant_option_type = settingData?.select_option == "all_options" ? "all_options" : "size";
  // console.log("///data///", data);
  document.querySelectorAll('.frenzy_pb_details .frenzy_bundle_product_grid').forEach(function(this_click){
    var product_handle = this_click.querySelector('.frenzy_bundle_product_details_inner .frenzy_bundle_product_checkbox_val').getAttribute('data-handle');
     var html =  this_click.querySelector('.frenzy_bundle_product_details_inner .frenzy_bundle_product_checkbox_val');

    bundle_frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle+'.js', html,settingData).then(frenzy_product_response => {return frenzy_product_response});
  });
}
// window.FrenzyBundleAfterDetailsCallBack = function(data, html){
//   (data || []).map(
//      ($bundle_product, $bundle_idx) => {
//        let $frenzy_bundle_sale_price = $bundle_product.org_price * 100,
//        $frenzy_bundle_compare_price = $bundle_product.org_price * 100;

//        var t = '';
//        t = document.querySelector('.frenzy_pb_details .frenzy_bundle_product_grid[data-index="'+$bundle_idx+'"]');

//       const product_handle = $bundle_product.org_prod_url.split("?");
//        bundle_frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', t).then(frenzy_product_response => {return frenzy_product_response});
       
//      });
// }

// window.frenzyCartCallBack = async (res) => {
//  document.querySelectorAll('li.HorizontalList__Item')[9].querySelector('a').click();
// }
function frenzyQuickAddClick(this_click){
  if(this_click.closest(".frenzy_product_item").querySelector('figure').querySelector('.frenzy_options.is-open')){
    this_click.closest(".frenzy_product_item").querySelector('figure').querySelector('.frenzy_options')?.classList.remove('is-open');
  }else{
    document.querySelector('.frenzy_options.is-open')?.classList.remove('is-open')
    this_click.closest(".frenzy_product_item").querySelector('figure').querySelector('.frenzy_options')?.classList.add('is-open');
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  const viewportWidth = document.documentElement.clientWidth;
  if(viewportWidth < 768){
    setTimeout(() => {
    const closeButton = document.querySelector('.frenzy_mobile_search_box_close_button');
    if(closeButton){
      closeButton.addEventListener('click',function(e){
        document.querySelector('#shopify-section-header').style.zIndex = '5';
        document.querySelector('#shopify-section-header').querySelector('#Search').setAttribute('aria-hidden','true');
        document.querySelector('.PageOverlay').classList.remove('is-visible');
        document.documentElement.classList.remove('no-scroll');
      });
    }
    },1000)
  }
});


